import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import $ from 'jquery';
import React, { useEffect, useRef, useState } from 'react';
import { baseurl } from '../utility/helper';
import Swal from 'sweetalert2';

const EventDeleted = () => {
  const roleid = parseInt(sessionStorage.getItem("userroleId"));
  const [Events, setEvents] = useState([]);
  const [selectedEvents, setSelectedEvents] = useState([]);
  const tableRef = useRef(null);

  const fetchEvents = async () => {
    try {
      const token = sessionStorage.getItem("token"); // or sessionStorage, or from state/context
      const response = await fetch(`${baseurl}/admin/deletedevent`, {
        method: 'GET',
        headers: {
          'Authorization': `${token}`, // Ensure token is sent
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      const formattedData = data.map(event => ({
        ...event,
        start_date: formatDateTime(event.start_date),
        end_date: formatDateTime(event.end_date),
      }));
      setEvents(formattedData);
    } catch (error) {
      console.error('Error fetching event:', error);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  useEffect(() => {
    const tableElement = tableRef.current;
  
    if (tableElement) {
      if ($.fn.DataTable.isDataTable(tableElement)) {
        $(tableElement).DataTable().destroy();
      }
  
      const dataTable = $(tableElement).DataTable({
        dom: 'Blfrtip',
        pageLength: 25,
        lengthMenu: [[10, 25, 50, 100, 250, 500, -1], [10, 25, 50, 100, 250, 500, "All"]],
        buttons: [
          { extend: 'copyHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
          { extend: 'excelHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
          { extend: 'csvHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
          { extend: 'pdfHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
          { extend: 'print', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
        ],
        data: Events,
        columns: [
          {
            data: null,
            title: '<input type="checkbox" id="select-all" />',
            orderable: false,
            render: (data, type, row) => `<input type="checkbox" class="row-select" data-id="${row.id}" />`,
          },
          { data: null, title: "Sr.No", className: "text-center" },
          { data: 'id', title: 'ID' },
          { data: 'title', title: 'Title' },
          { data: 'short_desc', title: 'Short Description' },
          { data: 'long_desc', title: 'Long Description' },
          { data: 'created_by', title: 'Created By' },
          { data: 'start_date', title: 'Start Date' },
          { data: 'end_date', title: 'End Date' },
          { data: null, title: 'Action', orderable: false },
        ],
        columnDefs: [
          {
            targets: 1,
            render: (data, type, row, meta) => meta.row + 1,
          },
          {
            targets: 2,
            render: (data) => `<center>${data}</center>`,
          },
          {
            targets: 9,
            render: (data, type, row) => {
              const restoreIcon = `<a href="#" class="restore-icon btn btn-warning btn-sm me-2" data-id="${row.id}"><i class="fas fa-trash-arrow-up"></i>&nbsp; Restore</a>`;
              const deleteIcon = roleid === 1 ? `<a href="#" class="delete-icon btn btn-danger btn-sm" style="color:white" data-id="${row.id}"><i class="fas fa-trash"></i> Delete Forever</a>` : '';
              return `${restoreIcon} ${deleteIcon}`;
            },
          },
        ],
      });
  
      // Select all checkboxes
$(document).on("click", "#select-all", function () {
  const checked = this.checked;

  // Get only visible event IDs
  const visibleEventIds = $(".row-select")
    .map(function () {
      return $(this).data("id");
    })
    .get(); // Convert jQuery object to array

  // Set selected events based on whether "Select All" is checked
  setSelectedEvents(checked ? [...new Set(visibleEventIds)] : []);
  
  $(".row-select").each(function () {
    $(this).prop("checked", checked).trigger("change");
  });
});

$(document).on('change', '.row-select', function () {
  const eventId = $(this).data('id');
  if (this.checked) {
    // Add the event ID only if it's not already in the selectedEvents
    setSelectedEvents((prev) => [...new Set([...prev, eventId])]);
  } else {
    // Remove the event ID from selectedEvents
    setSelectedEvents((prev) => prev.filter((id) => id !== eventId));
  }
});
  
      $(document).on('click', '.delete-icon', async function (e) {
        e.preventDefault();
        if (selectedEvents.length === 0) {
          Swal.fire('No Events Selected', 'Please select Events to delete.', 'warning');
          console.log('No Events selected', selectedEvents); // Add a log for debugging
          return;
        }
        const result = await Swal.fire({
          title: 'Are you sure?',
          text: 'Do you want to permanently delete the selected Events?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete!',
          cancelButtonText: 'Cancel',
        });

        if (result.isConfirmed) {
          try {
            const token = sessionStorage.getItem("token"); // or sessionStorage, or from state/context
            await Promise.all(
              selectedEvents.map(EventId =>
                $.ajax({
                  url: `${baseurl}/admin/eventlist/${EventId}?permanentdelete=true`,
                  type: 'DELETE',
                  headers: {
                    Authorization: `${token}`, // Replace 'yourAuthToken' with the actual token
                  },
                })
              )
            );
            Swal.fire('Deleted!', 'Selected Events deleted successfully.', 'success');
            fetchEvents(); // Re-fetch the Events after deletion
            setSelectedEvents([]); // Clear selected Events
          } catch (error) {
            console.error('Error deleting selected Events:', error);
            Swal.fire('Error', 'Error deleting selected Events.', 'error');
          }
        }
      });


      $(document).on('click', '.restore-icon', async function (e) {
        e.preventDefault();
        const EventId = $(this).data('id');
        const result = await Swal.fire({
          title: 'Are you sure?',
          text: 'Do you want to Restore this Event?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, Restore!',
          cancelButtonText: 'Cancel',
        });

        if (result.isConfirmed) {
          try {
            const token = sessionStorage.getItem("token"); // or sessionStorage, or from state/context
            await $.ajax({
              url: `${baseurl}/admin/eventsrestore/${EventId}`,
              type: 'PUT',
              headers: {
                Authorization: `${token}`, // Replace 'yourAuthToken' with the actual token
              },
            });
            Swal.fire('Restored!', 'Event Restore successfully.', 'success');
            // Re-fetch the Events after deletion
            fetchEvents();
          } catch (error) {
            console.error('Error Restore Event:', error);
            Swal.fire('Error', 'Error Restore Event.', 'error');
          }
        }
      });

      $(document).on('click', '.delete-icon', async function (e) {
        e.preventDefault();
        const EventId = $(this).data('id');
        const result = await Swal.fire({
          title: 'Are you sure?',
          text: 'Do you want to permanently delete this Event?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete!',
          cancelButtonText: 'Cancel',
        });

        if (result.isConfirmed) {
          try {
            const token = sessionStorage.getItem("token"); // or sessionStorage, or from state/context
            await $.ajax({
              url: `${baseurl}/admin/eventlist/${EventId}?permanentdelete=true`,
              type: 'DELETE',
              headers: {
                Authorization: `${token}`, // Replace 'yourAuthToken' with the actual token
              },
            });
            Swal.fire('Deleted!', 'Event permanently deleted successfully.', 'success');
            // Re-fetch the Events after deletion
            fetchEvents();
          } catch (error) {
            console.error('Error deleting Event:', error);
            Swal.fire('Error', 'Error deleting Event.', 'error');
          }
        }
      });

      return () => {
        if ($.fn.DataTable.isDataTable(tableElement)) {
          $(tableElement).DataTable().destroy();
        }
      };
    }
  }, [Events]);
  
  // Function to delete selected events
  const handleDeleteSelected = async () => {
    console.log("Selected Events before deletion:", selectedEvents);
  
    if (selectedEvents.length === 0) {
      Swal.fire("No Events Selected", "Please select Events to delete.", "warning");
      return;
    }
  
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to permanently delete the selected Events?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete!",
      cancelButtonText: "Cancel",
    });
  
    if (result.isConfirmed) {
      try {
        const token = sessionStorage.getItem("token");
  
        await Promise.all(
          selectedEvents.map((EventId) =>
            $.ajax({
              url: `${baseurl}/admin/eventlist/${EventId}?permanentdelete=true`,
              type: "DELETE",
              headers: {
                Authorization: `${token}`,
              },
            }).fail((jqXHR, textStatus, errorThrown) => {
              console.error(`Failed to delete Event ID ${EventId}:`, textStatus, errorThrown);
            })
          )
        );
  
        Swal.fire("Deleted!", "Selected Events deleted successfully.", "success");
  
        fetchEvents();
        setSelectedEvents([]); // **Reset selectedEvents after deletion**
      } catch (error) {
        console.error("Error deleting selected Events:", error);
        Swal.fire("Error", "Error deleting selected Events.", "error");
      }
    }
  };
  

  const formatDateTime = (timestamp) => {
    const date = new Date(timestamp);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  
  return (
    <div className="content container-fluid">
      <center><h1>Event Deleted Entries</h1></center>
      <div className="container mt-4">
        <div className="profile-section">
          <button onClick={handleDeleteSelected} className="btn btn-danger mb-3">Delete Selected List</button>
          <div className="list" style={{ overflow: "auto" }}>
            <div className="row">
              <div className="col-12">
                <table ref={tableRef} className="table table-striped table-bordered" style={{ width: '100%' }}></table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  
};

export default EventDeleted;
